import _objectWithoutProperties from "/codebuild/output/src875296868/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/codebuild/output/src875296868/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
const _excluded = ["children", "minHeight", "height", "marginTop"],
  _excluded2 = ["children", "minHeight", "justifyContent"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React from 'react';
import { colors } from '@guryou/colors';
import { borderDefinition, boxShadowLight, sizes, smallBorderRadius, spacer } from '@guryou/html-theme';
import { AppBar, Toolbar } from '@material-ui/core';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import propsToCss, { toPixel } from '../utils/propsToCss';
const Block = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  overflow-y: hidden;\n  margin: 0 auto;\n  ", ";\n"])), props => propsToCss(props));
const PaperBlock = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  padding: 20px;\n  box-shadow: ", ";\n  border-radius: ", ";\n  border: ", ";\n  margin: 0 auto;\n  ", ";\n"])), colors.white, boxShadowLight, smallBorderRadius, borderDefinition(), props => propsToCss(props));
const FlexColumn = styled(Block)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  ", "\n"])), _ref => {
  let {
    hover,
    hoverEffect
  } = _ref;
  return hover && "&:hover {\n    ".concat(Object.keys(hoverEffect).map(x => "".concat(x, ": ").concat(hoverEffect[x], ";")).join(''), "\n  }");
});
const FlexRow = styled(Block)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  overflow: unset;\n"])));
const GyAppBar = _ref2 => {
  let {
      children,
      minHeight,
      height,
      marginTop
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  const styles = {
    minHeight: toPixel(minHeight),
    height: toPixel(height),
    marginTop
  };
  return /*#__PURE__*/React.createElement(AppBar, _extends({
    style: styles
  }, props), children);
};
const GyToolbar = _ref3 => {
  let {
      children,
      minHeight,
      justifyContent
    } = _ref3,
    props = _objectWithoutProperties(_ref3, _excluded2);
  const styles = {
    minHeight: toPixel(minHeight),
    justifyContent
  };
  return /*#__PURE__*/React.createElement(Toolbar, _extends({
    style: styles
  }, props), children);
};

// Obsolete
const CenterMediumContent = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: ", "px;\n  padding: ", "\n  margin: ", "px auto;\n  margin-top: ", ";\n"])), sizes.medium, _ref4 => {
  let {
    isMobile
  } = _ref4;
  return isMobile ? '0' : "".concat(spacer.spacer2, "px");
}, spacer.spacer3, props => "".concat((props.isPublicContent ? -150 : 0) + spacer.spacer3, "px"));
const LittleCircle = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  width: 10px;\n  height: 10px;\n  border-radius: 50px;\n  background: '#fff';\n  border: '1px solid #000';\n  ", ";\n"])), props => propsToCss(props));
const VerticalLine = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 1px;\n  background: #252525;\n  ", ";\n"])), props => propsToCss(props));
Block.propTypes = {
  margin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  hover: PropTypes.object
};
Block.defaultProps = {
  padding: 0,
  margin: 1,
  xs: 12
};
FlexRow.defaultProps = {
  padding: 0,
  margin: 1,
  xs: 12
};
export { PaperBlock, Block, FlexColumn, FlexRow, GyAppBar as AppBar, GyToolbar as Toolbar, CenterMediumContent, LittleCircle, VerticalLine };